var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('v-col',{staticClass:"title pl-0 pr-0"},[_c('h1',[_vm._t("head2")],2),_vm._t("head2-extra")],2),_c('div',{staticClass:"inner-main"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }